import { useEffect, useRef } from "react";

/**
 * Wrap children to fade-up reveal on scroll.
 * Children get .reveal class — when intersected, .in-view is added.
 */
export default function Reveal({ children, className = "", delay = 0, as: As = "div", testId }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            el.classList.add("in-view");
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  const delayClass =
    delay === 1 ? "reveal-delay-1" :
    delay === 2 ? "reveal-delay-2" :
    delay === 3 ? "reveal-delay-3" :
    delay === 4 ? "reveal-delay-4" :
    delay === 5 ? "reveal-delay-5" : "";

  return (
    <As ref={ref} data-testid={testId} className={`reveal ${delayClass} ${className}`}>
      {children}
    </As>
  );
}
